import * as React from 'react';
import {
  buildGalleryLastSlideIpotekaUrl,
  trackGalleryLastSlideMortgageClick,
} from 'shared/utils/tracking/galleryLastSlideMortgageBanner';
import { TMortgageBannerVerticalName } from 'shared/utils/tracking/mortgageUnderPriceCianBanner';

/** Подмена ссылок в legacy-html баннере галереи и клик-аналитика. */
export function useGalleryMortgageBannerDomBridge(innerHTML: string, verticalName: TMortgageBannerVerticalName) {
  const containerRef = React.useRef<HTMLDivElement>(null);

  React.useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) {
      return;
    }

    const url = buildGalleryLastSlideIpotekaUrl(verticalName);
    const links = el.querySelectorAll<HTMLAnchorElement>('a[href*="ipoteka-main"]');
    const cleanups: Array<() => void> = [];

    links.forEach(anchor => {
      anchor.setAttribute('href', url);
      const handler = () => {
        trackGalleryLastSlideMortgageClick(verticalName);
      };
      anchor.addEventListener('click', handler);
      cleanups.push(() => anchor.removeEventListener('click', handler));
    });

    return () => {
      cleanups.forEach(c => c());
    };
  }, [innerHTML, verticalName]);

  return containerRef;
}
